export default "__VITE_ASSET__Bjcqw81r__"